import { useState } from 'react';
import { TeButton, TeContainerSlim, TeLoader, TePopover, TeText } from '@topcon/tuicl-react';
import { useTranslation } from 'react-i18next';

import { useRequestDetails } from '../../pages/Companies/companies.queries';

interface Props {
  companyId: string;
  requestToJoinId?: string;
}

function RequestToJoinInfoPopover({ companyId, requestToJoinId }: Props) {
  const { t } = useTranslation(['common']);
  const [clicked, setClicked] = useState(false);
  const {
    data: requestDetails,
    isLoading,
    isError,
    isFetched,
  } = useRequestDetails(clicked ? requestToJoinId : undefined);
  const popoverId = `request-to-join-info-${companyId}`;
  const reviewers = requestDetails?.reviewers ?? [];
  const showError = isError || (isFetched && reviewers.length === 0);

  const renderContent = () => {
    if (!isFetched || isLoading) {
      return (
        <TeContainerSlim gap="xs" alignItems="center" padding={['xs', 'm']}>
          <TeLoader size="s" />
          <TeText color="text.inverse" size={14}>
            {t('loading', { ns: 'common' })}
          </TeText>
        </TeContainerSlim>
      );
    }

    if (showError) {
      return (
        <TeContainerSlim padding={['xs', 'm']} style={{ maxWidth: 280 }}>
          <TeText color="text.inverse" size={14}>
            {t('requestToJoinContactRetrievalFailed', { ns: 'common' })}
          </TeText>
        </TeContainerSlim>
      );
    }

    return (
      <TeContainerSlim padding={['xs', 'm']} column gap="xs2" style={{ maxWidth: 280 }}>
        <TeText color="text.inverse" weight={700} size={14}>
          {t('requestToJoinSentTo', { ns: 'common' })}
        </TeText>
        <TeContainerSlim column gap="s">
          {reviewers.map((reviewer) => (
            <TeText key={reviewer.email} color="text.inverse" size={14}>
              {reviewer.email}
            </TeText>
          ))}
          <TeText color="text.inverse" size={14}>
            {t('requestToJoinIncorrectAddress', { ns: 'common', count: reviewers.length })}
          </TeText>
        </TeContainerSlim>
      </TeContainerSlim>
    );
  };

  return (
    <>
      <TeButton
        variant="neutral"
        size="s"
        icon="info"
        popkey={popoverId}
        teclick={() => setClicked(true)}
      />
      <TePopover for={popoverId} variant="secondary" operation="click" placement="bottom">
        {renderContent()}
      </TePopover>
    </>
  );
}

export default RequestToJoinInfoPopover;
